/**
 * Created by pawel on 17/11/16.
 * Copyright (c) 2016 ITerativ GmbH. All rights reserved.
 */
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Store } from "@ngrx/store";
import { GetLabels } from "../admin/labels/labels.actions";
import { AppState } from "../reducers";

@Injectable()
export class LabelsLoadResolve  {

    constructor(private store: Store<AppState>) {}

    resolve(route: ActivatedRouteSnapshot): Observable<Event> {
        this.store.dispatch(new GetLabels());
        return;
    }
}
